import { useTranslation } from "react-i18next";

interface PlaceholderPageProps {
  title: string;
  description: string;
}

export default function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 flex h-14 items-center border-b border-border bg-background/80 backdrop-blur-xl px-6">
        <div>
          <h1 className="text-lg font-semibold text-foreground">{title}</h1>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
      </header>
      <div className="flex items-center justify-center h-[calc(100vh-3.5rem)]">
        <div className="text-center animate-slide-in max-w-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-accent">
            <span aria-hidden className="text-2xl">∎</span>
          </div>
          <h2 className="text-lg font-semibold text-foreground mb-1">{t("placeholder.heading")}</h2>
          <p className="text-sm text-muted-foreground">{t("placeholder.body", { title })}</p>
        </div>
      </div>
    </div>
  );
}
